export const baseUrl = `https://admin.swipezonesports.com/v1/`
export const fileUrl = `https://d2kj0g1j712gqj.cloudfront.net/`